import PTooltip from './src/main';

/* istanbul ignore next */
PTooltip.install = function (Vue) {
    Vue.component(PTooltip.name, PTooltip);
};

export default PTooltip;
